import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["rowsPerPageOptions", "initialRowsPerPage"];
import * as React from 'react';
import { createRegisteredContext } from 'react-singleton-context';
import usePagination from '../hooks/usePagination';
import { jsx as _jsx } from "react/jsx-runtime";
const PAGINATION_OPTIONS = [15, 25, 50];
const INITIAL_ROWS_PER_PAGE = 25;
const PaginationContext = createRegisteredContext('ContainerTablePaginationContext', undefined);
export const usePaginationContext = () => {
  const context = React.useContext(PaginationContext);
  if (!context) {
    throw new Error('usePaginationContext should be used within a PaginationProvider');
  }
  return context;
};
/**
 * @ignore - internal component.
 */
export function PaginationProvider(_ref) {
  let {
      rowsPerPageOptions,
      initialRowsPerPage
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const values = usePagination({
    paginationOptions: rowsPerPageOptions || PAGINATION_OPTIONS,
    initialRowsPerPage: initialRowsPerPage || INITIAL_ROWS_PER_PAGE
  });
  return /*#__PURE__*/_jsx(PaginationContext.Provider, _extends({
    value: values
  }, props));
}